import { defineMessages } from 'react-intl';

export const skinAnalyserMessages = defineMessages({
  skinAnalyserTitle: {
    id: 'pd.skinAnalyserTitle',
    defaultMessage: 'Diagnostika pleti online',
  },
  skinAnalyserDescriptionVariant: {
    id: 'pd.skinAnalyserDescriptionVariant',
    defaultMessage: 'Nechte si doporučit péči na míru s {brandName}',
  },
  skinAnalyserRunDiagnostic: {
    id: 'pd.skinAnalyserRunDiagnostic',
    defaultMessage: 'Vyzkoušet',
  },
});
